import { scalePoint } from '@visx/vendor/d3-scale';
import scaleOperator from "../operators/scaleOperator.js";
export const updatePointScale = scaleOperator('domain', 'range', 'reverse', 'align', 'padding', 'round');
export default function createPointScale(config) {
  return updatePointScale(scalePoint(), config);
}